export const defaultPage = 0;
export const pageSize = 10;
